import React from 'react';
import { MaestroIcon } from '../../../assets/Icons/SVG';

const PaymentLogos = () => {
  return (
    <>
      <div className="payment-logo">
        <i className="fa-brands fa-cc-visa"></i>
      </div>
      <div className="payment-logo">
        <i className="fa-brands fa-cc-mastercard"></i>
      </div>
      <div className="payment-logo">
        <i className="fa-brands fa-cc-jcb"></i>
      </div>
      <div className="payment-logo">
        <i className="fa-brands fa-cc-diners-club"></i>
      </div>
      <div className="payment-logo">
        <i className="fa-brands fa-cc-discover"></i>
      </div>
      <div className="payment-logo maestro">
        <MaestroIcon />
      </div>
    </>
  );
};

export default PaymentLogos;
